var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"min-height":"400px"}},[_c('div',{ref:"chart",staticClass:"mx-6"})])
}
var staticRenderFns = []

export { render, staticRenderFns }